<template>
  <div class="langwrap">
    <div class="lang" role="group" aria-label="Language">
      <button
        type="button"
        :class="{ on: localeValue === 'en' }"
        :aria-pressed="localeValue === 'en'"
        @click="switchLocale('en')"
      >
        EN
      </button>
      <button
        type="button"
        :class="{ on: localeValue === 'ar' }"
        :aria-pressed="localeValue === 'ar'"
        @click="switchLocale('ar')"
      >
        &#x0639;
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
const { locale, setLocale } = useI18n();

const localeValue = computed(() => (locale.value === 'ar' ? 'ar' : 'en'));

function persistLocale(next: 'en' | 'ar') {
  if (typeof document !== 'undefined') {
    // Keep behaviour aligned with @nuxtjs/i18n default cookie key so the
    // selected locale survives navigation + hard refresh (SPA external redirects).
    document.cookie = `i18n_redirected=${encodeURIComponent(next)}; path=/; max-age=31536000`;
  }

  if (typeof localStorage !== 'undefined') {
    localStorage.setItem('app_locale', next);
  }
}

async function switchLocale(next: 'en' | 'ar') {
  if (localeValue.value === next) return;
  persistLocale(next);
  await Promise.resolve(setLocale(next));
}
</script>

<style scoped>
.langwrap {
  position: absolute;
  top: clamp(24px, 4vh, 40px);
  right: clamp(24px, 4vw, 40px);
  left: auto;
  z-index: 10;
}

:global(html[dir='rtl'] .langwrap),
:global(body[dir='rtl'] .langwrap) {
  right: auto;
  left: clamp(24px, 4vw, 40px);
}

.lang {
  display: inline-flex;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 999px;
  padding: 3px;
  gap: 2px;
}

.lang button {
  border: none;
  background: transparent;
  cursor: pointer;
  font: inherit;
  font-size: 13px;
  font-weight: 600;
  color: #64748b;
  padding: 7px 18px;
  border-radius: 999px;
  transition:
    background 0.18s,
    color 0.18s;
  min-width: 48px;
}

.lang button.on {
  background: #0f172a;
  color: #fff;
}

.lang button:not(.on):hover {
  color: #0f172a;
}

@media (max-width: 540px) {
  .langwrap {
    top: 20px;
    right: 22px;
  }

  :global(html[dir='rtl'] .langwrap),
  :global(body[dir='rtl'] .langwrap) {
    left: 22px;
    right: auto;
  }
}
</style>
